/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let poa_updates = {};
let has_poa = false;
let has_normal = false;
let price_tiers = [];

function exVat() {
  $('.price-inc-vat').hide();
  $('.price-exc-vat').show();
  $('.vat_toggle_slider').removeClass('incVat');
  $('.incVat-label').removeClass('vat_toggle_active');
  $('.excVat-label').addClass('vat_toggle_active');
}

function incVat() {
  $('.price-inc-vat').show();
  $('.price-exc-vat').hide();
  $('.vat_toggle_slider').addClass('incVat');
  $('.incVat-label').addClass('vat_toggle_active');
  $('.excVat-label').removeClass('vat_toggle_active');
}

function decideVat() {
  if (localStorage.getItem('incVat') == 'true') {
    incVat();
  }
  else {
    exVat();
  }  
}

function calculateNewTier(new_value){
  price_tiers.forEach(function(tier){
    if (new_value == tier.lower) {
      console.log(tier.title);
      $(`.product-form__single-selector[value="${tier.title}"]`).click(); 
    }
    else if (new_value > tier.lower) {
      if (tier.end_tier) {
        console.log(tier.title);
        $(`.product-form__single-selector[value="${tier.title}"]`).click();
      }
      else {
        if (new_value <= tier.upper) {
          console.log(tier.title);
          $(`.product-form__single-selector[value="${tier.title}"]`).click();
        }
      }
    }
  }); 
}

$('document').ready(function(){  
  
  console.log('incVat', localStorage.getItem('incVat'));
  decideVat();
  
  if ($('[name="checkout"]')) {
      $('[name="checkout"]').removeAttr('disabled');
  	  $('[name="checkout"]').removeClass('button--disabled');
  }
  
  if ($('#poa-form-submit')) {
    $('#poa-form-submit').removeAttr('disabled');
    $('#poa-form-submit').removeClass('button--disabled');
  }
  
  $('body').on('change', '.vat_toggle_switch input', function(e){
//     $('.vat_toggle_label').each(function(index){
//       $(this).toggleClass('vat_toggle_active');
//     });
    if (localStorage.getItem('excVat') == 'true') {
      localStorage.setItem('excVat', 'false');
      localStorage.setItem('incVat', 'true');
      console.log('incVat', localStorage.getItem('incVat'));
      incVat();
    }
    else {
      localStorage.setItem('excVat', 'true');
      localStorage.setItem('incVat', 'false');
      console.log('incVat', localStorage.getItem('incVat'));
      exVat();
    }
  });
  
  $('body').on('click', '.incVat-label', function(){
  	localStorage.setItem('excVat', 'false');
    localStorage.setItem('incVat', 'true');
    console.log('incVat', localStorage.getItem('incVat'));
    incVat();
  });
  
  $('body').on('click', '.excVat-label', function(){
  	localStorage.setItem('incVat', 'false');
    localStorage.setItem('excVat', 'true');
    console.log('incVat', localStorage.getItem('incVat'));
    exVat();
  });
  
  $('body').on('click', '[name="checkout"]', function(e){
  	e.preventDefault();
    let thisButton = $(this)[0];
    let cartForm = thisButton.closest('form');
    let discountCode = '';
    let cartFormAction = cartForm.getAttribute('action');
    const discountRegex = /\?discount=trade_/;
    let strSearch = cartFormAction.search(discountRegex);
    if (strSearch != -1){
      discountCode = cartFormAction.slice(strSearch);

    }
    $('[name="checkout"]').attr('disabled', 'disabled');
    $('[name="checkout"]').addClass('button--disabled');
    let poa_items = [];
    poa_updates = {};
    has_poa = false;
    has_normal = false;
    $.ajax({
      type: 'get',
      url: '/cart.js',
      success: function(cart){
        console.log(cart);
        cart.items.forEach((item) => {
          if (item.price == 0) {
            poa_items.push({
              title: item.title,
              sku: item.sku,
              quantity: item.quantity
            });
            poa_updates[item.variant_id] = 0;
            has_poa = true;
          }
          else {
            has_normal = true;
          }
        });
        
        console.log(poa_items);
        console.log(poa_updates);
        
        if (has_poa) {
          document.querySelector('#poa-form-items').value = poa_items.map((item) => {
          	return `${item.title} ${item.sku} x${item.quantity}`
          }).join('; ');
          $('#shopify-section-poa-form').show();
        }
        else {
          window.location.href = '/checkout' + discountCode;
        }
      },
      error: function(response){
        console.log(response);
        window.location.href = '/checkout' + discountCode;
      },
      dataType: 'JSON'
    });
  });
  
  $('body').on('click', '.poa-close', function(e){
  	$('#shopify-section-poa-form').hide();
    $('[name="checkout"]').removeAttr('disabled');
  	$('[name="checkout"]').removeClass('button--disabled');
  });
  
  $('body').on('click', '#poa-form-submit', function(e){
    e.preventDefault();
    console.log(poa_updates);
    $('#poa-form-submit').attr('disabled', 'disabled');
    $('#poa-form-submit').addClass('button--disabled');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        updates: poa_updates
      },
      success: function(response){
      	console.log(response);
        if (has_normal) {
          $('#poa').submit();
        }
        else {
          document.querySelector('[name="return_to"]').value = '/';
          $('#poa').submit();
        }
      },
      error: function(response){
        console.log(response);
        window.location.href = '/checkout';
      },
      dataType: 'JSON'
    });
  });
  
  if ($('.default_tier') && $('.default_tier').length > 0) {
   	let default_tier = $('.default_tier').val();
    let default_quantity = parseInt(default_tier.split('-')[0]);
    $(`.product-form__single-selector[value="${default_tier}"]`).click();
    $('.quantity-selector__value').val(default_quantity);
    
    price_tiers = [];
    $('.price_tiers').each(function(index){
      let title = $(this).val();
      let title_array = title.split('-');
      let end_tier = true;
      let upper = false;
      let lower = parseInt(title_array[0]);
      if (title_array.length > 1) {
   		end_tier = false;
        upper = parseInt(title_array[1]);
      }
      price_tiers.push({
        title: title,
        end_tier: end_tier,
        lower: lower,
        upper: upper
      });
    });
    
    console.log(price_tiers);
  }
});
